import './style.css';
import PersonalInfo from './personalInfo';
import Intro from './intro';
import Education from './education';
import Skills from './skills';
import Projects from './projects';
import Socials from './socials';

function App() {
  return (<>
      <PersonalInfo/>
      <Intro/>
      <Education/>
      <Skills/>
      <Projects/>
      <Socials/>
  </>);
}

export default App;
